import React, { useState } from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import DownloadIcon from "@mui/icons-material/Download";
import { vendorApi } from "../../api/api";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";

const ProjectDocuments = ({ documentData }) => {
    // console.log(documentData);
  const navigate = useNavigate();
  const [documents,setDocuments]=useState(documentData);
  const handleDownload = async (id, filename = "document.pdf") => {
  try {
    const response = await vendorApi.downloadProjectDocument(id);

    const blob = new Blob([response.data], { type: 'application/pdf' }); 
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(url); 
  } catch (error) {
    console.error("Download failed", error);
    alert("Failed to download the document.");
  }
};
const handleDelete = async (docId) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this document?");
    if (!confirmDelete) return;

    try {
    
      const response = await vendorApi.deleteDocumentById({id:docId,type:1});   
      setDocuments((prev) => prev.filter((doc) => doc.id !== docId));
    } catch (error) {
      console.error("Failed to delete document:", error);
      alert("Error deleting document.");
    }
  };

  const openPdf = (url) => {
    window.open(url, "_blank");
  };

  const navigateToAll = () => {
  navigate("/documents/viewall",{state:{
      documentData , type :1
     }});
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ color: "#13216e", fontWeight: 600, fontSize: "20px", mb: 2 }}>
        Property Documents
      </Typography>

      {documents?.length > 0 ? (
        <>
          {documents.slice(0, 3).map((doc) => (
            <Box
              key={doc.id}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                p: 1,
                mb: 1,
                borderRadius: 1,
                backgroundColor: "#f5f5f5",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <PictureAsPdfIcon color="error" />
                <Typography>{doc.documentName}</Typography>
              </Box>
              <Box>
                <IconButton onClick={() => openPdf(doc.documentUrl)} aria-label="view" size="small">
                  <OpenInNewIcon />
                </IconButton>
                 <IconButton onClick={() => handleDelete(doc.id)} aria-label="delete" size="small">
                  <DeleteIcon color="error" />
                </IconButton>
                <IconButton
                  onClick={() => handleDownload(doc.id, doc.documentName)}
                  aria-label="download"
                  size="small"
                  color="primary"
                >
                  <DownloadIcon />
                </IconButton>
              </Box>
            </Box>
          ))}
          <Button onClick={navigateToAll} size="small" variant="outlined" color="primary" sx={{ mt: 2 }}>
            View All Documents
          </Button>
        </>
      ) : (
        <Typography sx={{ color: "#999", fontSize: "14px", marginTop: "1rem" }}>
          No Documents Available
        </Typography>
      )}
    </Box>
  );
};

export default ProjectDocuments;
